import React from 'react';
import { Chip, theme } from '@hiver/hiver-ui-kit';
import { Container } from './style';

export const Badge = ({children, ...rest}) => {
    return(
        <Container {...rest}>
            {children}
        </Container>
    )
}

export const NewBadge = ({ styles = {} }) => (
    <Chip
        className='newIcon'
        label="New" variant="filled" sx={{
        color: theme.palette.gray.gray1,
        fontWeight: "500",
        background: "linear-gradient(160deg, #FFE250 0%, #FFC350 100%)",
        ...styles
    }}/>
)

export const CustomHiverBadge = ({ label, additionalStyles={} }) => (
    <Chip 
        label={label} variant="filled" sx={{
            color: theme.palette.gray.gray1,
            fontWeight: "500",
            background: "linear-gradient(160deg, #FFE250 0%, #FFC350 100%)",
            lineHeight: "16px",
            ...additionalStyles
    }}/>
)